import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link, browserHistory } from 'react-router'
import { Form, Field, reduxForm, SubmissionError } from 'redux-form'
import { CONFIRM_RESET_PASS_REQUEST } from '../../actions/actions'
import { PulseLoader } from 'halogen'
import {
  Row,
  Col,
  Grid,
  Panel,
  PanelBody,
  PanelContainer,
} from '@sketchpixy/rubix'
import * as MabnaButton from '../common/Button/Button'

const styles = {
  spinner: {
    height: 45,
    margin: '20px 0',
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
}

class ConfirmResetPass extends Component {
  constructor(props) {
    super(props)
    this.state = { newPassSubmitted: false }
  }

  onSubmit = values => {
    const {
      dispatch,
      params: { uid, token },
    } = this.props

    let formData = new FormData()

    formData.append('new_password', values.new_password)
    formData.append('uid', uid)
    formData.append('token', token)

    return new Promise((resolve, reject) => {
      dispatch({
        type: CONFIRM_RESET_PASS_REQUEST,
        formData,
        resolve,
        reject,
      })
    })
      .then(() => this.setState({ newPassSubmitted: true }))
      .catch(errors => {
        throw new SubmissionError({ ...errors.form_errors })
      })
  }

  newPasswordInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <div className="reset-pass">
        <div className="form-error">{hasError && error}</div>
        <input
          type="password"
          className="border-focus-blue"
          placeholder="گذرواژه جدید"
          {...input}
          {...custom}
        />
      </div>
    )
  }

  confNewPasswordInput = ({ input, meta: { touched, error }, ...custom }) => {
    let hasError = touched && error !== undefined
    return (
      <div className="reset-pass">
        <div className="form-error">{hasError && error}</div>
        <input
          type="password"
          className="border-focus-blue"
          placeholder="تکرار گذرواژه جدید"
          {...input}
          {...custom}
        />
      </div>
    )
  }

  render() {
    const { handleSubmit, error } = this.props

    return (
      <div className="signup ltr">
        <div id="auth-row">
          <div id="auth-cell">
            <Grid>
              <Row className="signup-container">
                <Col
                  sm={4}
                  md={6}
                  smOffset={4}
                  mdOffset={3}
                  xs={10}
                  xsOffset={1}
                  collapseLeft
                  collapseRight
                >
                  <PanelContainer controls={false}>
                    <Panel>
                      <PanelBody style={{ padding: 0 }}>
                        <div
                          className="text-center bg-darkblue fg-white"
                          style={{ padding: 10 }}
                        >
                          <h3 style={{ margin: 0, padding: 10 }}>بازیابی گذرواژه</h3>
                        </div>

                        <div id="signup-success">
                          {!this.state.newPassSubmitted && (
                            <div>
                              <h4>لطفا گذرواژه جدید را وارد کنید</h4>
                            </div>
                          )}

                          {!this.state.newPassSubmitted ? (
                            <Form onSubmit={handleSubmit(this.onSubmit)}>
                              <div className="form-error">{error && error}</div>
                              <Field
                                name="new_password"
                                component={this.newPasswordInput}
                              />

                              <Field
                                name="confirm_new_password"
                                component={this.confNewPasswordInput}
                              />

                              <MabnaButton.Primary
                                lg
                                style={{ marginRight: '10px' }}
                                outline
                                onClick={() => browserHistory.push('/')}
                              >
                                بازگشت
                              </MabnaButton.Primary>

                              {!this.props.aSyncCall ? (
                                <MabnaButton.Primary
                                  type="submit"
                                >
                                  ثبت گذرواژه
                                </MabnaButton.Primary>
                              ) : (
                                <div style={styles.spinner}>
                                  <PulseLoader color="#275C8A" size="10px" />
                                </div>
                              )}
                            </Form>
                          ) : (
                            <div>
                              <h4>گذرواژه جدید ثبت شد</h4>
                              <Link to="/">ورود به سیستم</Link>
                            </div>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                  </PanelContainer>
                </Col>
              </Row>
            </Grid>
          </div>
        </div>
      </div>
    )
  }
}

const validate = values => {
  let errors = {}

  if (!values.new_password) {
    errors.newPassword = 'لطفا گذرواژه جدید را وارد کنید'
  }

  if (values.new_password !== values.confirm_new_password) {
    errors.confirm_new_password = 'گذواژه ها باید یکسان باشند'
  }

  if (!values.confirm_new_password) {
    errors.confirm_new_password = 'لطفا گذرواژه جدید را مجددا وارد کنید'
  }

  return errors
}

ConfirmResetPass = reduxForm({
  form: 'confirmResetPassword',
  validate,
})(ConfirmResetPass)

function mapStateToProps(state) {
  return { aSyncCall: state.auth.aSyncCall }
}

export default connect(mapStateToProps)(ConfirmResetPass)



// WEBPACK FOOTER //
// ./src/components/authentication/ConfirmRestPass.js